export default {
    table: {
        titles: {
            reserved_by: 'Rezervisao',
            received: 'Primio',
            offer: 'Usluga',
            location: 'Lokacija',
            created_date: 'Kreirano datuma',
            scheduled_for: 'Vrijeme rezervacije',
            status: 'Status',
        },
    },
    other: {
        add_to_calendar: 'Dodaj u kalendar',
        tooltip:
            'Klikom na ovo dugme, rezervacija će biti dodata u vaš Apple ili Google kalendar. Email adresa osobe koja je izvršila rezervaciju automatski će biti kopirana u clipboard, kako biste mogli jednostavno dodati korisnika ili gosta na događaj.',
    },
}
